import { render, staticRenderFns } from "./CustomPriceList.vue?vue&type=template&id=89d4b358&"
import script from "./CustomPriceList.vue?vue&type=script&lang=js&"
export * from "./CustomPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports